import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import s from './RangeTabs.module.css';

export default function RangeTabs({ options, value, onChange }) {
  const containerRef = useRef(null);
  const [indicator, setIndicator] = useState({ left: 0, width: 0 });

  const measure = useCallback(() => {
    const activeBtn = containerRef.current?.querySelector(`[data-value="${value}"]`);
    if (activeBtn) setIndicator({ left: activeBtn.offsetLeft, width: activeBtn.offsetWidth });
  }, [value]);

  useLayoutEffect(() => {
    measure();
  }, [measure, options]);

  useLayoutEffect(() => {
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [measure]);

  return (
    <div className={s.tabs} ref={containerRef}>
      <span
        className={s.indicator}
        style={{ transform: `translateX(${indicator.left}px)`, width: `${indicator.width}px` }}
      />
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          data-value={opt.value}
          className={`${s.tab} ${value === opt.value ? s.tabActive : ''}`}
          aria-pressed={value === opt.value}
          onClick={(e) => onChange(opt.value, e)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
